<template>
  <div>
    <!-- <SectionHeader header="Authorised Officer" image="uiw-font-person" :active="primaryApplicant && !primaryApplicant.confirmed" /> -->
    <SectionHeader header="Authorised Officer (1)" image="uiw-font-person" :active="primaryApplicant && !primaryApplicant.confirmed" />

    <div v-if="!primaryApplicant.confirmed" style="min-height: 300px">
      <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded text-center" v-if="user && user.id != primaryApplicant.userId">
        <QBtn color="primary" no-caps :to="{ name: 'logout' }">Logout</QBtn>
      </div>
      <div class="bg-white q-pa-md q-mt-sm q-mb-md rounded" v-if="user && user.id == primaryApplicant.userId">
        <label class="field-label">1. Do you wish to continue as the nominated Authorised Officer for the application?*</label>
        <div class="q-pa-xs">
          <label class="block q-pb-xs">
            <QRadio v-model="continueValue" val="yes" label="Yes" />
            <QRadio v-model="continueValue" val="no" label="No" />
          </label>
        </div>
        <div v-if="continueValue == 'yes'">
          <div class="q-pa-xs" v-if="entityType != 'IND'">
            <label class="field-label">2. Does the business have more than 1 Authorised Officer?*</label>
            <label class="block q-pb-xs">
              <QRadio v-model="hasSecondaryApplicant" val="yes" label="Yes" />
              <QRadio v-model="hasSecondaryApplicant" val="no" label="No" />
            </label>
          </div>
          <div class="q-px-md q-py-md text-center">
            <QBtn color="primary" @click="confirmAndContiue" :disable="!disableConfirmAndContiue" no-caps :loading="loadingOnConfirm">
              Confirm & Continue</QBtn
            >
          </div>
        </div>
        <div v-if="continueValue == 'no'">
          <QForm @submit.prevent="onSubmit">
            <label class="field-label">2. Please nominate an Authorised Officer below.</label>
            <InputField
              label="First Name"
              placeholder="First Name"
              v-model="form.firstName"
              :required="true"
              :minLength="2"
              :maxLength="40"
            />
            <InputField label="Last Name" placeholder="Last Name" v-model="form.lastName" :required="true" :minLength="2" :maxLength="40" />
            <InputField
              label="Email"
              placeholder="Email"
              v-model="form.email"
              type="email"
              :required="true"
              :minLength="2"
              :maxLength="55"
            />
            <InputField
              v-if="region == 'NZ'"
              label="Mobile Number"
              placeholder="Mobile Number"
              v-model="form.phone"
              :required="true"
              type="tel"
              :minLength="9"
              :maxLength="12"
            />
            <InputField
              v-else
              label="Mobile Number"
              placeholder="Mobile Number"
              v-model="form.phone"
              type="tel"
              :required="true"
              :length="10"
            />
            <div class="q-px-md q-py-md text-center">
              <QBtn color="primary" type="submit" no-caps :disable="!userInfoComputed" :loading="loadingOnReAssign"> Submit </QBtn>
            </div>
          </QForm>
          <NewApplicantDialog
            v-if="showNewApplicantDialog"
            @closeNewApplicantDialog="closeNewApplicantDialog"
            :company="scoreboard.companyDetails.companyName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { QBtn, QForm, QRadio } from 'quasar';
import { mapState, mapActions } from 'vuex';
import SectionHeader from '@/components/Atoms/SectionHeader';
import InputField from '@/components/Atoms/InputField';
import NewApplicantDialog from '@/components/Molecules/NewApplicantDialog.vue';
import MutateSelectPrimaryApplicant from '@/graphql/mutations/MutateSelectPrimaryApplicant';
import MutateCreateOrUpdateProperty from '@/graphql/mutations/MutateCreateOrUpdateProperty';
import MyCustomFunctions from '@/mixins/MyCustomFunctions.js';
import { GLOBAL_ERROR } from '@/components/GlobalError/GlobalError';

export default {
  name: 'CalculatorConfirmPrimary',
  components: {
    SectionHeader,
    QBtn,
    QForm,
    InputField,
    QRadio,
    NewApplicantDialog
  },
  mixins: [MyCustomFunctions],
  data: function () {
    return {
      form: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null
      },
      hasSecondaryApplicant: null,
      loadingOnConfirm: false,
      loadingOnReAssign: false,
      showNewApplicantDialog: false,
      continueValue: null
    };
  },
  computed: {
    ...mapState({
      scoreboard: (state) => state.vehicleApplication.vehicleApplication.scoreboard,
      user: (state) => state.auth.user
    }),
    primaryApplicant() {
      return this.scoreboard?.primaryApplicant ? this.scoreboard?.primaryApplicant : null;
    },
    entityType() {
      if (
        this.scoreboard &&
        this.scoreboard.entityDetails &&
        (this.scoreboard.entityDetails.entityType == 'IND' || this.scoreboard.entityDetails.entityType == 'Sole_Trader')
      )
        return 'IND';
      return null;
    },
    disableConfirmAndContiue() {
      if (this.entityType != 'IND' && this.hasSecondaryApplicant) return true;
      else if (this.entityType == 'IND') return true;
      else return false;
    },
    userInfoComputed() {
      if (this.form.firstName && this.form.lastName && this.form.email && this.form.phone)
        return {
          firstName: this.form.firstName,
          lastName: this.form.lastName,
          email: this.form.email,
          phone: this.form.phone
        };
      return false;
    },
    region() {
      return this.scoreboard?.currentUser?.region ? this.scoreboard?.currentUser?.region : 'AU';
    }
  },
  methods: {
    ...mapActions({
      updateVehicleApplicationState: 'vehicleApplication/updateVehicleApplicationState'
    }),
    confirmAndContiue: async function () {
      this.loadingOnConfirm = true;
      // add error catching
      if (this.hasSecondaryApplicant)
        await this.updateVehicleApplication(this.hasSecondaryApplicant, 'entityDetails', 'hasSecondaryApplicant');

      await this.updateVehicleApplication('yes', 'primaryApplicant', 'confirmed');
      setTimeout(() => {
        this.$emit('primaryApplicantCreated');
      });
      this.loadingOnConfirm = false;
    },
    closeNewApplicantDialog: function () {
      this.showNewApplicantDialog = false;
      this.$router.push({ name: 'logout' });
    },
    onSubmit: async function () {
      const userInfo = this.userInfoComputed;

      if (!userInfo) return;

      this.loadingOnReAssign = true;
      await this.$apollo
        .mutate({
          mutation: MutateSelectPrimaryApplicant,
          variables: {
            isCurrentUserPrimary: false,
            vehicleApplicationStatus: '',
            userInfo: userInfo
          }
        })
        .then(async (data) => {
          setTimeout(() => {
            this.loadingOnReAssign = false;
            this.showNewApplicantDialog = true;
          });
        })
        .catch((error) => {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          if (error) {
            this.$euiNotifications.emit({
              notification: GLOBAL_ERROR
            });
          }
        });
      this.loadingOnReAssign = false;
    }
  }
};
</script>
